import React from 'react';
import PropTypes from 'prop-types'


const IconBox = (props) => {
    let iconlower = props.title.toLowerCase();
    iconlower = iconlower.split(" ");
    iconlower = iconlower.join("");
    return (
        <div className={`icon-box ${iconlower}`}>
            {(props.badminton === "") ? <i style={{color: props.color}} className={`fa-solid fa-${props.icon}`} ></i> : <img src={props.badminton} alt='badminton.svg'></img>}
            <h2 style={{ color: "white" }}>{props.title}</h2>
        </div>
    );
};
IconBox.propTypes = {
    badminton : PropTypes.string
}
IconBox.defaultProps = {
    badminton: "",
}
export default IconBox;
